var _a;

import Item from './item';
/** @jsx jsx */

import { jsx } from '@emotion/core';
import { COLORS, FONT } from '../../../constants';
import { breakpoints } from '../../shared';
var tabs = (_a = {
  background: COLORS.white,
  overflowX: 'auto',
  whiteSpace: 'nowrap',
  padding: '0 16px',
  fontFamily: FONT.family
}, _a[breakpoints.medium] = {
  padding: '0 24px'
}, _a[breakpoints.large] = {
  padding: '0 32px'
}, _a);

var Tabs = function Tabs(_a) {
  var children = _a.children;
  return jsx("div", {
    css: tabs
  }, children);
};

Tabs.Item = Item;
export default Tabs;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/tabs/index.js
// module id = 378
// module chunks = 0